export default "__VITE_ASSET__etQgD7Cf__"